<template>
    <div class="contentWrapper">
        <div class="contentBlock">
            <h3>{{$t('text.FPageSelectPlatform')}}</h3>
            <p><b>{{$t('text.FPageW4MSubtitle')}}</b></p>
            <div class="row">
                <div class="col-md-6">
                    <div class="panel" :class="opt=='w4m'?'panel-button-info-selected':'panel-button-info'" @click="SelectPlatform('w4m')">
                        <div class="panel-icon pull-left"><i class="fa-solid fa-square-check" v-if="opt=='w4m'"></i><i class="fa-regular fa-square" v-else></i></div>
                        <div class="panel-text"><h4 class="text-center">RENEWATION</h4>{{$t('text.MPageForW4M')}}</div>
                    </div>
                </div>
                <div class="col-md-6">
                   
                    <div class="panel" :class="opt=='wum'?'panel-button-danger-selected':'panel-button-danger'" @click="SelectPlatform('wum')">
                        <div class="panel-icon pull-left"><i class="fa-solid fa-square-check" v-if="opt=='wum'"></i><i class="fa-regular fa-square" v-else></i></div>
                        <div class="panel-text"><h4 class="text-center">RENEWATION HD</h4>{{$t('text.MPageForWUM')}}</div>
                    </div>
                </div>
            </div>
            <div class="well well-sm" v-if="!opt">
                <p>{{$t('text.FPageAbout')}}</p>
            </div>
            <div v-if="opt=='w4m'">
                <h3>{{$t('text.FPageW4MTitle')}}</h3>
                
                <p>{{$t('text.FPageW4M1')}}</p>
          
                <div class="well well-sm">
                    <b>{{$t('text.FPageW4MWarning1')}}</b> 
                </div>
                <p>{{$t('text.FPageW4M2')}}</p>
                <div class="well well-sm">
                    <b>{{$t('text.FPageW4MWarning2')}}</b>
                </div>  
                <p>{{$t('text.FPageW4M3')}}</p>
                <div class="alert alert-warning">
                    <b>{{$t('text.FPageHelpWarning')}} <a @click="NewTabUrlOpen($store.state.discordURL)"><i class="fab fa-discord"></i> Discord</a>!</b>
                </div> 
                <div class="btn-group btn-group-justified">
                    <div class="btn-group">
                        <button type="button" class="btn btn-primary" @click="NewTabUrlOpen($store.state.modURL1)"><span class="btn-icon"><i class="fa-solid fa-download fa-flip"></i></span>{{$t('text.ButtonDownloadW4M1')}}</button>
                    </div>
                    <div class="btn-group">
                        <button type="button" class="btn btn-info" @click="NewTabUrlOpen($store.state.modURL2)"><span class="btn-icon"><i class="fas fa-file-archive fa-flip"></i></span>{{$t('text.ButtonDownloadW4M2')}}</button>
                    </div>
                </div>
            </div>
            <div v-else-if="opt=='wum'">
                <h3>{{$t('text.FPageWUMTitle')}}</h3>
                <p>{{$t('text.FPageWUM1')}}</p>
          
                <div class="well well-sm">
                    <b>{{$t('text.FPageWUMWarning2')}}</b>
                </div>  
                <p>{{$t('text.FPageWUM2')}}</p>
                <div class="panel" v-for="(update, index) in $store.state.updates">
                    <div class="panel-heading panel-spoiler" @click="OpenCloseSpoiler(index)">
                        <div class="panel-icon"><i class="fa-regular fa-square-minus" v-if="openSpoilerID == index"></i><i class="fa-regular fa-square-plus" v-else></i></div>
                        <div class="panel-text"><b>{{$t('text.FPageWhatsNew',{date: GetLocalDate(update.date)})}}</b></div>
                    </div>
                    <div class="panel-footer panel-spoiler-footer" :class="openSpoilerID == index?'none':'spoiler-closed'">
                        <ul>
                            <li v-for="(note,index) in update.notes">{{$store.state.setLanguage=='en'?note[1]:note[0]}} <router-link :to="'/content'+note[2]" v-if="note[2]"><a>{{$t('text.ButtonReadMore')}}</a></router-link>;</li>
                        </ul>
                    </div>
                </div>
                <div class="alert alert-warning">
                    <b>{{$t('text.FPageHelpWarning')}} <a @click="NewTabUrlOpen($store.state.discordURL)"><i class="fab fa-discord"></i> Discord</a>!</b>
                </div>  
                <div class="btn-group btn-group-justified">
                    <div class="btn-group">
                        <button type="button" class="btn btn-warning" @click="NewTabUrlOpen($store.state.modHDURL1)"><span class="btn-icon"><i class="fas fa-download fa-flip"></i></span>{{$t('text.ButtonDownloadWUM1')}}</button>
                    </div>

                    <div class="btn-group">
                        <button type="button" class="btn btn-danger" @click="NewTabUrlOpen($store.state.modHDURL2)"><span class="btn-icon"><i class="fas fa-file-archive fa-flip"></i></span>{{$t('text.ButtonDownloadWUM2')}}</button>
                    </div>
                </div>
                <ul class="nav nav-pills nav-justified">
                  <li role="presentation" @click="NewTabUrlOpen($store.state.modHDMirror1)"><a href="#">Download from Mirror (0.2A EXE)</a></li>
                  <li role="presentation" @click="NewTabUrlOpen($store.state.modHDMirror2)"><a href="#">Download from Mirror (0.2A ZIP)</a></li>
                </ul>
            </div> 
        </div>
    </div>
</template>

<script>
export default {
    name: 'Files',
    data () {
        return {
            opt: 'none',
            openSpoilerID: 0
        }   
    },
    watch: {
        $route(to, from) {
            this.opt = this.$route.params.option
        }            
    },
    mounted() {
        this.opt = this.$route.params.option
    },
    methods: {
        GetLocalDate(val) {
            let setDate = new Date(val)
            if(this.$store.state.setLanguage != 'ru'){
                val = setDate.toLocaleDateString('en-GB', {day : 'numeric', month : 'short', year : 'numeric'}).split(' ').join('-')
            }
            else {
                val = setDate.toISOString().slice(0,10).split('-').reverse().join('.')
            }
            return val
        },
        OpenCloseSpoiler(val) {
            val != this.openSpoilerID? this.openSpoilerID = val : this.openSpoilerID = -1
        },
        NewTabUrlOpen(val){
            alert(val)
            window.open(val, '_blank')
        },
        SelectPlatform(val){
            this.$router.push({ path: `/files/`+val })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btnDiscordLayout {
   margin-bottom: 5px;
}
.updateSpanLayout {
   margin-bottom: 10px;
}
.patchnotes {
    height: 200px;
    background-color: #444444;
    color: #eeeeee;
    text-align: left;
    border: 5px;
    border-color: #ff9999;
    margin-bottom: 5px;
    padding: 5px 10px;
    overflow-y:scroll;
}
.panel-button-info {
    display: flex;
    align-items: center;
    width: 100%;
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1;
    padding: 10px 15px;
    border: 1px solid transparent;
    -webkit-box-shadow: 0 1px 1px rgba(0,0,0,0.05);
    box-shadow: 0 1px 1px rgba(0,0,0,0.05);
    cursor: pointer;
}
.panel-button-info-selected {
    display: flex;
    align-items: center;
    width: 100%;
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1;
    padding: 10px 15px;
    border: 1px solid transparent;
    -webkit-box-shadow: 0 1px 1px rgba(0,0,0,0.05);
    box-shadow: 0 1px 1px rgba(0,0,0,0.05);
    cursor: auto;
}
.panel-button-info:hover, .panel-button-info:active, .panel-button-info selected {
    background-color: #5bc0de;
    color: #ffffff;
    -webkit-box-shadow: 0 1px 5px rgba(0,0,0,0.05);
    box-shadow: 0 1px 5px rgba(0,0,0,0.05);
}
.panel-button-danger {
    display: flex;
    align-items: center;
    width: 100%;
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
    padding: 10px 15px;
    border: 1px solid transparent;
    -webkit-box-shadow: 0 1px 1px rgba(0,0,0,0.05);
    box-shadow: 0 1px 1px rgba(0,0,0,0.05);
    cursor: pointer;
}
.panel-button-danger:hover, .panel-button-danger:active {
    background-color: #d9534f;
    color: #ffffff;
    -webkit-box-shadow: 0 1px 5px rgba(0,0,0,0.05);
    box-shadow: 0 1px 5px rgba(0,0,0,0.05);
}
.panel-button-danger-selected {
    display: flex;
    align-items: center;
    width: 100%;
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
    padding: 10px 15px;
    border: 1px solid transparent;
    -webkit-box-shadow: 0 1px 1px rgba(0,0,0,0.05);
    box-shadow: 0 1px 1px rgba(0,0,0,0.05);
    cursor: auto;
}
.panel-icon {
    font-size: 30px;
    width: 30px;
    flex-basis: 0;
    line-height: 100%;
}
.panel-text {
    width: calc(100% - 30px);
    text-align: center;
}
.panel-spoiler {
    padding: 3px 8px;
    color: #444444;
    display: flex;
    align-items: center;
    width: 100%;
}
.panel-spoiler:hover, panel-spoiler:active {
  background-color: #e6e6e6;
  border-color: #adadad;
}
.panel-spoiler-footer {
    padding: 0px 5px 0px 5px;
    max-height: 500px;
    overflow: hidden;
    -webkit-transition: max-height .5s;
    transition: max-height .5s ease;
}
.spoiler-closed {
    max-height: 0;
    overflow: hidden;
    -webkit-transition: max-height .5s;
    transition: max-height .5s ease;
}
h3 {
    margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Files.vue